<template>
  <div class="chat-message d-flex mb-3" :class="isUser ? 'justify-content-end' : 'justify-content-start'">
    <div
      class="message-bubble p-3 rounded-3"
      :class="isUser ? 'bg-primary text-white' : 'bg-body-tertiary border'"
    >
      <div class="small fw-semibold mb-1 opacity-75">
        {{ isUser ? 'You' : 'AI assistant' }}
        <span v-if="message.elapsed" class="ms-1">({{ message.elapsed }} s)</span>
      </div>
      <!-- User text is shown verbatim; assistant text is rendered as markdown. -->
      <div v-if="isUser" class="message-text" style="white-space: pre-wrap;">{{ message.content }}</div>
      <div v-else-if="!message.content" class="text-muted fst-italic">
        <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
        Thinking…
      </div>
      <div v-else class="message-text" v-html="renderedHtml"></div>
    </div>
  </div>
</template>

<script>
import { renderMarkdown } from '@/utils/renderMarkdown';

export default {
  name: 'ChatMessage',
  props: {
    message: { type: Object, required: true },
  },
  computed: {
    isUser() {
      return (this.message.role || this.message.source) === 'user';
    },
    renderedHtml() {
      try {
        return renderMarkdown(this.message.content);
      } catch (e) {
        return this.message.content || '';
      }
    },
  },
};
</script>

<style scoped>
.message-bubble {
  max-width: 85%;
  word-break: break-word;
}
.message-text :deep(pre) {
  background-color: var(--bs-gray-800, #2b3035);
  color: var(--bs-light, #e9ecef);
  padding: 0.75rem;
  border-radius: 0.5rem;
  overflow-x: auto;
}
.message-text :deep(p:last-child) {
  margin-bottom: 0;
}
</style>
